export function Preloader(_props: {
  faviconUrl?: string | null;
  /**
   * The site's display name, used only for the badge below when there is no usable
   * icon. Optional so the overlay still renders correctly before `/api/seo` answers.
   */
  siteName?: string | null;
}) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center overflow-hidden bg-[#070d1a]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,rgba(234,179,8,0.12),transparent_34%),linear-gradient(180deg,rgba(255,255,255,0.03),transparent_45%)]" />
      <div className="relative flex w-full max-w-sm flex-col items-center gap-5 px-6 text-center">
        <div className="h-px w-48 overflow-hidden rounded-full bg-white/10">
          <div className="h-full w-1/2 animate-[preloader-slide_1.4s_ease-in-out_infinite] rounded-full bg-gradient-to-r from-transparent via-primary to-transparent" />
        </div>
        <div className="flex items-center gap-2.5" aria-hidden="true">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary" />
          <span className="h-1.5 w-8 overflow-hidden rounded-full bg-white/10">
            <span className="block h-full w-1/2 animate-[preloader-slide_1.2s_ease-in-out_infinite] rounded-full bg-primary/80" />
          </span>
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary/70 [animation-delay:0.2s]" />
        </div>
      </div>
    </div>
  );
}
